<template>
  <div class="team-counter">
    <SupernodeSeatCallout
      v-if="isSupernodeOrEnterpriseTier || isWithinSeatExcess"
    />
    <BittsLoading :is-loading="!ready">
      <div class="team-counter__seat-cards">
        <TeamCounterCard
          :count="coreSeatCount"
          :limit="coreSeatBase"
          :excess="coreSeatExcess"
          title="Full Access Seats"
          :requests="fullAccessRequests"
          @open-add-seats-modal="() => (isAddSeatsModalVisible = true)"
        />
        <TeamCounterCard
          :count="salesSeatCount"
          :limit="salesSeatBase"
          :excess="salesSeatExcess"
          title="Sales Seats"
          :requests="salesAccessRequests"
        />
        <TeamCounterCard
          v-if="showIntegrationCard"
          :count="integrationSeatCount"
          :limit="integrationSeatBase"
          :excess="integrationSeatExcess"
          title="Integration Seats"
        />
      </div>
    </BittsLoading>
    <AddSeatsModal v-if="isAddSeatsModalVisible" @closed="onCloseModal" />
  </div>
</template>

<script setup lang="ts">
import { BittsLoading } from '@crossbeam/bitts';

import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import AddSeatsModal from '@/components/billing/AddSeatsModal.vue';
import SupernodeSeatCallout from '@/components/billing/SupernodeSeatCallout.vue';
import TeamCounterCard from '@/components/team/TeamCounterCard.vue';

import useSeats from '@/composables/useSeats';
import {
  allReady,
  useBillingStore,
  useSeatRequestsStore,
  useTeamStore,
} from '@/stores';

const isAddSeatsModalVisible = ref(false);

const billingStore = useBillingStore();
const teamStore = useTeamStore();
const seatRequestsStore = useSeatRequestsStore();
const { isSupernodeOrEnterpriseTier } = storeToRefs(billingStore);
const { fullAccessRequests, salesAccessRequests } =
  storeToRefs(seatRequestsStore);

const ready = allReady(teamStore, billingStore, seatRequestsStore);

const router = useRouter();

async function onCloseModal() {
  isAddSeatsModalVisible.value = false;
  const query = { ...route.query };
  delete query.open_add_seats;
  await router.push({
    ...route,
    query,
  });
}

const {
  coreSeatCount,
  coreSeatBase,
  coreSeatExcess,
  salesSeatCount,
  salesSeatBase,
  salesSeatExcess,
  integrationSeatCount,
  integrationSeatBase,
  integrationSeatExcess,
  isWithinSeatExcess,
  canUseIntegrationSeats: showIntegrationCard,
} = useSeats();

const route = useRoute();
watch(
  () => route.query,
  () => {
    if (route.query.open_add_seats) {
      isAddSeatsModalVisible.value = true;
    }
  },
);
</script>
<style lang="pcss" scoped>
@reference "../../css/theme.css";
.team-counter {
  @apply flex flex-col gap-16;
}
.team-counter__seat-cards {
  @apply flex justify-between gap-24;
}
</style>
